import { SimpleFormFlowField } from '../../../../../Models/SimpleFormFlowField';
import { IPrimaryFields } from './../FormFlowViewModel/IPrimaryFields';
import { ValueIsProperty } from './ValueIsProperty';
import { AutoFillDefinition } from './AutoFillDefinition';
import { ValueIs } from './ValueIs';
import { FileTypes } from '../../../../../Constants/FileTypes';
import { LinkedFieldTreeMapping } from './LinkedFieldTreeMapping';
import { JsonChange } from './json-change.model';
import { FieldMapping } from './FieldMapping';
import { ValueIsPropertyOperators } from '@app/Constants/ValueIsPropertyOperators';

export class Field {
    FieldName: string;
    DefaultName: string;
    GroupName: string;
    UiGroupName: string;
    MultiFieldName: string;
    FieldId: string;
    FieldUniqueId: string;
    FieldType: string;
    IsMandatory: boolean;
    IsMandatoryForFeed: boolean;
    IsMarkdown: boolean;
    HelpText: string;
    DefaultDescription: string;
    ListType: string;
    ListAlias: string;
    IsOfType: string;
    IsCustomField: boolean;
    OriginalFieldId: string;
    IsMultiLine: boolean;
    HasTime: boolean;
    index: number;
    IsAlwaysHidden: boolean;
    Modified: boolean;
    VisibleWhenOrRules: ValueIsProperty[];
    MandatoryWhenOrRules: ValueIsProperty[];
    HideWhenOrRules: ValueIsProperty[];
    VisibleWhenRules: ValueIsProperty[];
    MandatoryWhenRules: ValueIsProperty[];
    HideWhenRules: ValueIsProperty[];
    ListParams: Record<string, string>;
    Json: string;
    Order: number;
    ListValueType: 'AIRSWEBLIST';
    AutoFillDefinition: AutoFillDefinition;
    CalculationType: number;
    DrivingField: SimpleFormFlowField;
    DrivingAttribute: string;
    LinkedRecordModuleId: string;
    LinkedRecordField: Field;
    LinkedRecordFieldId: string;
    ListField: Field;
    LinkedFields: Field[];
    TargetListAttribute: string;
    LookupType: string;
    IsMulti: boolean;
    MultipleItemName: string;
    MultipleTypePropertyName: string;
    MultiFields: Field[];
    PrimaryFields: IPrimaryFields;
    HasPrimaryField: boolean;
    ControlType: string;
    ModelPropertyNames: string[];
    AllowLinkingToNewRecord: boolean;
    AllowLinkingToExistingRecords: boolean;
    RelationshipDescription: string;
    MaximumNumberOfItems: number;
    AllowedFileTypes: FileTypes[];
    ParentPropertyName: string;
    Path: string[];
    DisplayName: string;
    FieldFilterName: string;
    KeepExistingValues: boolean;
    HideOnUdq: boolean;
    IncludeInSwift: boolean;
    CascadeChanges: boolean;
    RegexRestrict: string;
    LinkedFieldTreeMappings: LinkedFieldTreeMapping[];
    IsFullControlButReadOnly: boolean;
    EscalationApplicableModuleStatusIds: number[];
    Changes: JsonChange[];
    IsProtected: boolean;
    ReasonForChange: string;
    AutoSelectWhenListHasOnlyOneItem: boolean;
    MappedListItemLabel: string;
    MatrixName: string;
    RenderAndHide: boolean;
    SimpleUserListPermissionsFilter: boolean;
    SimpleUserListSelectedModule: string;
    SimpleUserListSelectedPermission: string;
    Mappings: FieldMapping[];

    static parseMultiJsonString(jsonString: string): Field {
        if (!jsonString) {
            return;
        }
        const field: Field = JSON.parse(jsonString);
        return field;
    }
    static getVisibilityRuleState(field: Field, type: any, listAlias: string): boolean {
        return (field.VisibleWhenOrRules && (field
            .VisibleWhenOrRules
            .filter((r: ValueIsProperty) =>
                (r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value))
            ).length > 0))
            ||
            (field.VisibleWhenRules && (field
                .VisibleWhenRules
                .filter((r: ValueIsProperty) =>
                    (r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value))
                ).length > 0));
    }

    static getHideRuleState(field: Field, type: any, listAlias: string): boolean {
    return (
      (field.HideWhenOrRules &&
        field.HideWhenOrRules.filter(
          (r: ValueIsProperty) =>
            r.PropertyName === listAlias &&
            (r.ValueIs.Value === type.Value ||
              r.ValueIs.Identifier === type.Value)
        ).length > 0) ||
      (field.HideWhenRules &&
        field.HideWhenRules.filter(
          (r: ValueIsProperty) =>
            r.PropertyName === listAlias &&
            (r.ValueIs.Value === type.Value ||
              r.ValueIs.Identifier === type.Value)
        ).length > 0)
    );
    }

  static toggleHideRuleState(
    field: Field,
    type: any,
    listAlias: string,
    isBooleanField: boolean = false
  ) {
        field.HideWhenRules = field.HideWhenRules || [];
        field.HideWhenOrRules = field.HideWhenOrRules || [];
        const allRules = field.HideWhenRules.concat(field.HideWhenOrRules);
    const existing = allRules.find(
      (r) => r.PropertyName === listAlias && r.ValueIs.Value === type.Value
    );
        if (existing) {
            allRules.splice(allRules.indexOf(existing), 1);
    } else {
            const newProp = new ValueIsProperty();
            newProp.PropertyName = listAlias;
            newProp.ValueIs = new ValueIs();
            if (isBooleanField) {
                newProp.ValueIs.Identifier = type.Value;
                newProp.ValueIs.Value = null;
      } else {
                newProp.ValueIs.Value = type.Value;
                newProp.ValueIs.Identifier = 'value_string';
            }
            allRules.push(newProp);
        }
        if (allRules.length === 1) {
            return {
                HideWhenOrRules: [],
        HideWhenRules: allRules,
            };
    } else {
            return {
                HideWhenOrRules: allRules,
        HideWhenRules: [],
            };
        }
    }

  static toggleVisibilityRuleState(
    field: Field,
    type: any,
    drivingField: Field
  ) {
        let allRules: ValueIsProperty[];

        if (field.VisibleWhenOrRules && field.VisibleWhenRules) {
            allRules = field.VisibleWhenRules.concat(field.VisibleWhenOrRules);
    } else if (field.VisibleWhenOrRules) {
            allRules = field.VisibleWhenOrRules;
    } else {
            allRules = field.VisibleWhenRules;
        }

    const existing = this.findExistingProperty(allRules, type, drivingField);

    if (existing) {
      allRules.splice(allRules.indexOf(existing), 1);
    } else if (drivingField.ListType === 'MultiDropDown' || drivingField.ListType === 'MultiCheckbox') {
      const newProp = new ValueIsProperty();
      newProp.PropertyName = drivingField.FieldId;
      newProp.ValueIs = new ValueIs();
      newProp.ValueIs.Value = type.Value;
      newProp.ValueIs.Identifier = 'contains';
      allRules.push(newProp);
    } else {
      const newProp = new ValueIsProperty();
      newProp.PropertyName = drivingField.FieldId;
      newProp.ValueIs = new ValueIs();
      newProp.ValueIs.Value = type.Value;
      newProp.ValueIs.Identifier = 'value_string';
      allRules.push(newProp);
    }

        if (allRules.length === 1) {
            return {
                VisibleWhenOrRules: [],
        VisibleWhenRules: allRules,
            };
    } else {
      return {
        VisibleWhenOrRules: allRules,
        VisibleWhenRules: []
      };
        }
  };

    static getMandatoryRuleState(field: Field, type: any, listAlias: string): boolean {
        return (field.MandatoryWhenOrRules && field
            .MandatoryWhenOrRules
            .filter((r: ValueIsProperty) =>
                (r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value))
            ).length > 0)
            ||
            (field.MandatoryWhenRules && field
                .MandatoryWhenRules
                .filter((r: ValueIsProperty) =>
                    (r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value))
                ).length > 0);
  };

  static toggleMandatoryRuleState(field: Field, type: any, drivingField: Field) {
    const allRules = field.MandatoryWhenRules.concat(field.MandatoryWhenOrRules);
    const existing = this.findExistingProperty(allRules, type, drivingField);

    if (existing) {
      allRules.splice(allRules.indexOf(existing), 1);
    } else if (drivingField.ListType === 'MultiDropDown' || drivingField.ListType === 'MultiCheckbox') {
      const newProp = new ValueIsProperty();
      newProp.PropertyName = drivingField.FieldId;
      newProp.ValueIs = new ValueIs();
      newProp.ValueIs.Value = type.Value;
      newProp.ValueIs.Identifier = 'contains';
      allRules.push(newProp);
    } else if(drivingField.Mappings?.some(m => m.ControlPropertyName === 'SelectedItemAsBoolean')) {
      const newProp = new ValueIsProperty();
      newProp.PropertyName = drivingField.FieldId;
      newProp.ValueIs = new ValueIs();
      newProp.ValueIs.Identifier = type.Value;
      newProp.ValueIs.Value = null;
      allRules.push(newProp);
    }
    else {
      const newProp = new ValueIsProperty();
      newProp.PropertyName = drivingField.FieldId;
      newProp.ValueIs = new ValueIs();
      newProp.ValueIs.Value = type.Value;
      newProp.ValueIs.Identifier = ValueIsPropertyOperators.ValueString;
      allRules.push(newProp);
    }

        if (allRules.length === 1) {
            return {
                MandatoryWhenOrRules: [],
                MandatoryWhenRules: allRules
            };
    } else {
            return {
                MandatoryWhenOrRules: allRules,
                MandatoryWhenRules: []
            };
        }
  };

  static findExistingProperty(allRules: ValueIsProperty[], type: any, drivingField: Field): ValueIsProperty {
    return allRules.find(r => r.PropertyName === drivingField.FieldId
      && (r.ValueIs.Value != null ? r.ValueIs.Value === type.Value : r.ValueIs.Identifier === type.Value));
  };
}
